export default __webpack_public_path__ + "static/media/Call2.e182d97d.svg";